import { useWindowDimensions } from "react-native";
import { createDrawerNavigator } from "@react-navigation/drawer";

import StocksReportsScreen from "../../../screens/Reports/StocksReportScreens/StocksReportScreen";
import SalesScorecardScreen from "../../../screens/Reports/SalesScorecardScreens/SalesScorecardScreen";
import UsageSalesScorecardScreen from "../../../screens/Reports/UsageSalesScorecardScreens/UsageSalesScorecardScreen";
import ValueSalesScorecardScreen from "../../../screens/Reports/ValueSalesScorecardScreens/ValueSalesScorecardScreen";
import InvoiceDNDetailScreen from "../../../screens/Reports/InvoiceDNDetailScreens/InvoiceDNDetailScreen";
import PrdouctsReportsScreen from "../../../screens/Reports/ProductsReportScreens/ProductsReportScreen";
import ProductionStocksReportScreen from "../../../screens/Reports/ProductionStocksReportScreen";
import RawMaterialStocksReportScreen from "../../../screens/Reports/RawMaterialReportScreens/RawMaterialStocksReportScreen";
import RawMaterialStocksOverviewReportScreen from "../../../screens/Reports/RawMaterialReportScreens/RawMaterialStocksOverviewReportScreen";
import CustomerStatusReportsScreen from "../../../screens/Reports/CustomerStatusReportScreens/CustomerStatusReportScreen";
import PmxInventoryReportScreen from "../../../screens/Reports/PmxReportScreens/PmxInventoryReportScreen";
import PmxDetailsInventoryReportScreen from "../../../screens/Reports/PmxReportScreens/PmxDetailsInventoryReportScreen";
import { drawerItemsMain } from "./ReportsDrawerItemsMain";
import CustomDrawerContent from "../../../components/custom/CustomDrawerContent";
import { useEffect, useState } from "react";
import { userClaimInformation } from "../../../models/usersModel";
import { useSelector } from "react-redux";
import teamConfig from "../../../utils/constants/teams";
import rolesConfig from "../../../utils/constants/roles";

import DynamicWidthScreen from "../../../screens/NotUsed/DynamicWidthScreen";
import StockReportDetailsReportScreen from "../../../screens/Reports/StocksReportScreens/StockReportDetailsReport";
import ProductionStockDetailsReportScreen from "../../../screens/Reports/ProductionStockDetailsReportScreen";
import PmxInventoryDetailsReportScreen from "../../../screens/Reports/PmxReportScreens/PmxInventoryDetailsReportScreen";
import PmxDetailsInventoryDetailReportScreen from "../../../screens/Reports/PmxReportScreens/PmxDetailsInventoryDetailReportScreen";
import CustomerStatusDetailReportScreen from "../../../screens/Reports/CustomerStatusReportScreens/CustomerStatusDetailReportScreen";
import { useTranslation } from "../../../utils/useTranslation";

import { useAppTheme } from "../../../hooks/useAppTheme";

const Drawer = createDrawerNavigator();

export default function ReportsDrawerNavigator() {
  const { colors } = useAppTheme();
  const { t } = useTranslation();
  const dimensions = useWindowDimensions();
  const [userProfile, setUserProfile] = useState<userClaimInformation>();
  const { userInfo, currentRole } = useSelector(
    (state: any) => state.configurations,
  );

  const { warehouse } = teamConfig.teams;
  const isAdminOrOwner = [
    rolesConfig.roles.admin,
    rolesConfig.roles.owner,
  ].includes(currentRole?.toUpperCase());

  useEffect(() => {
    setUserProfile(userInfo);
  }, [userInfo]);

  return (
    <Drawer.Navigator
      initialRouteName="Home"
      screenOptions={{
        drawerStyle: {
          width: 180,
        },
        drawerLabelStyle: {
          fontSize: 12,
          textTransform: "none",
        },
        drawerType: dimensions.width >= 768 ? "front" : "front", //'permanent' : 'front',
        headerTintColor: colors.text,
      }}
      drawerContent={(props) => (
        <CustomDrawerContent
          drawerItems={drawerItemsMain(
            userProfile?.team.toUpperCase(),
            isAdminOrOwner,
            dimensions.width < 768
          )}
          {...props}
        />
      )}
    >
      <Drawer.Screen
        name="Stocks"
        component={StocksReportsScreen}
        options={{ title: t("stock") }}
      />
      {userProfile?.team.toUpperCase() !== warehouse && (
        <>
          <Drawer.Screen
            name="ProductionStocks"
            component={ProductionStocksReportScreen}
            options={{ title: t("productionStock") }}
          />
          <Drawer.Screen
            name="ProductionStockDetailsReportScreen"
            component={ProductionStockDetailsReportScreen}
            options={{ title: t("productionStockDetails") }}
          />
          <Drawer.Screen
            name="RawMaterialStocksOverView"
            component={RawMaterialStocksOverviewReportScreen}
            options={{ title: t("rawMaterialOverview") }}
          />
          <Drawer.Screen
            name="RawMaterialStocksDetails"
            component={RawMaterialStocksReportScreen}
            options={{ title: t("rawMaterialStock") }}
          />
        </>
      )}
      <Drawer.Screen
        name="WarehouseInventory"
        component={PmxInventoryReportScreen}
        options={{ title: t("inventoryOverview") }}
      />
      <Drawer.Screen
        name="PmxInventoryDetailsReportScreen"
        component={PmxInventoryDetailsReportScreen}
        options={{ title: t("inventoryOverviewDetails") }}
      />
      <Drawer.Screen
        name="WarehouseDetailsInventory"
        component={PmxDetailsInventoryReportScreen}
        options={{ title: t("inventoryDetail") }}
      />
      <Drawer.Screen
        name="PmxDetailsInventoryDetailReportScreen"
        component={PmxDetailsInventoryDetailReportScreen}
        options={{ title: t("inventoryDetailReport") }}
      />
      {userProfile?.team.toUpperCase() !== warehouse && (
        <Drawer.Screen
          name="Products"
          component={PrdouctsReportsScreen}
          options={{ title: t("searchProduct") }}
        />
      )}
      <Drawer.Screen
        name="CustomerStatus"
        component={CustomerStatusReportsScreen}
        options={{ title: t("customerStatus") }}
      />
      <Drawer.Screen
        name="CustomerStatusDetailReportScreen"
        component={CustomerStatusDetailReportScreen}
        options={{ title: t("customerStatusDetails") }}
      />
      {process.env.NODE_ENV !== "production" && (
        <Drawer.Screen
          name="DynamicWidth"
          component={DynamicWidthScreen}
          options={{ title: t("dynamicWidth") }}
        />
      )}

      <Drawer.Screen
        options={{
          drawerLabel: "StockReportDetailsReportScreen",
          title: t("stockReportDetails"),
        }}
        name="StockReportDetailsReportScreen"
        component={StockReportDetailsReportScreen}
      />

      {isAdminOrOwner && (
        <>
          {
            <>
              <Drawer.Screen
                name="SalesScorecard"
                component={SalesScorecardScreen}
                options={{ title: t("salesScorecardTitle") || "Sales Scorecard - Year On Year Usage" }}
              />
              <Drawer.Screen
                name="UsageSalesScorecard"
                component={UsageSalesScorecardScreen}
                options={{ title: t("usageSalesScorecardTitle") || "Usage Sales Scorecard — Monthly Usage" }}
              />
              <Drawer.Screen
                name="ValueSalesScorecard"
                component={ValueSalesScorecardScreen}
                options={{ title: t("valueSalesScorecardTitle") || "Value Sales Scorecard — Monthly Value" }}
              />
              <Drawer.Screen
                name="InvoiceDNDetail"
                component={InvoiceDNDetailScreen}
                options={{ title: t("invoiceDNDetail") }}
              />
            </>
          }
        </>
      )}
    </Drawer.Navigator>
  );
}
